export const Categories = {

  "Fever": {
    "cm": {"hi": "बुखार", "en": "Fever"},
    "caseCode": "Fever",
    "aclist": ["Fever"],
    "friendlyName": "bukhar, bukar, bimar, fever, fivar, fiver, garm, garam, tapna, temperature fewer, kapkapi",
    "gm": {"hi": "बुखार", "gid": "Fever", "en": "Fever"},
    "impl": "yes",
    "iconAsset": "Fever.webp",
    icon_webp_url: "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Ffever.webp?alt=media&token=fc71d603-7a0c-422a-8f6d-53a48119a66c",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_fever.png?alt=media&token=766c9bc0-c0d6-48ed-913b-e8273f35d17f"
  },
  
  
  "Breathlessness": {
    "cm": {"hi": "सांस लेने में तकलीफ़", "en": "Breathlessness"},
    "caseCode": "Breathlessness",
    "aclist": ["Breathlessness"],
    "friendlyName": "saas phoolti sas foolna sans fulna saans fhulti sas bharti breathless breathlessness breathing asthma asthama difficult in breath ghabrat ",
    "gm": {"hi": "सांस लेने में तकलीफ़", "gid": "Breathlessness", "en": "Breathlessness"},
    "impl": "yes",
    "iconAsset": "Breathlessness.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fbreathlessness.webp?alt=media&token=2802772f-8c97-411c-bb6d-1fcef5c1fb67",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_breathlessness.png?alt=media&token=defc859c-bb79-49f1-9306-04f4ecd18c69"
  },
  
   "Common Cold":{
    "cm": {"hi": "सामान्य जुखाम", "en": "Common Cold"},
    "caseCode": "Common Cold",
    "aclist": ["Common Cold"],
    "friendlyName": "jukam zukam sardi naak se pani cold cough khasi khansi khashi kasi jukham zhukam common flu chik nose comman coman cuf kashi comen commen behna",
    "gm": {"hi": "सामान्य जुखाम", "gid": "Common Cold", "en": "Common Cold"},
    "impl": "yes",
    "iconAsset": "CommonCold.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fcommon_cold.webp?alt=media&token=531b93f2-50c4-4100-81d5-9ffda41cf093",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_common_cold.png?alt=media&token=03ace142-08ff-4c92-8878-bf0fdc0bf155"
  },
  
  "Acidity": {
    "cm": {"hi": "पेट में जलन", "en": "Acidity"},
    "caseCode": "Acidity",
    "aclist": ["Acidity"],
    "friendlyName": "jalan, pitt, pet mai jalan, gas, gas, seene, jalan, khatti, dakar, ges, gastric, drd, gastritis, ji,  gabrana,  phulna, fulna, kabj, bharipan, marode, pait, dard, burning, kabji, fullness, stomach, gasteric",
    "gm": {"hi": "पेट मुद्दे", "gid": "Stomach", "en": "Stomach Issues"},
    "impl": "yes",
    "iconAsset": "Acidity.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Facidity.webp?alt=media&token=d5b81d1f-e35c-4d80-bf0b-55cebf99e68e",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_acidity.png?alt=media&token=3a92202c-01d8-4c73-b6ca-413ee65ad35d"
  },
  
  "Loose Motion": {
    "cm": {"hi": "दस्त", "en": "Loose Motions"},
    "caseCode": "LooseMotion",
    "aclist": ["LooseMotion"],
    "friendlyName": "dast, diarrhoea, pet kharab, lose motion, patla mal, dasth, stool, diarrhea, luse motion, lusmotion, pachis, loosemotion, diarrhea",
    "gm": {"hi": "पेट मुद्दे", "gid": "Stomach", "en": "Stomach Issues"},
    "impl": "yes",
    "iconAsset": "LooseMotion.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Floose-motions.webp?alt=media&token=aec44265-a3a8-493b-b94b-b3627c0c8567",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_loose_motion.png?alt=media&token=1a9112a0-ad1c-40b0-a2fa-b6515e030b27"
  },

  "Headache": {
    "cm": {"hi": "सिरदर्द", "en": "Headache"},
    "caseCode": "Headache",
    "aclist": ["Headache"],
    "friendlyName": "sardard, sar, sir, matha, migrane, migrain, sirdard, head",
    "gm": {"hi": "सिरदर्द", "gid": "Headache", "en": "Headache"},
    "impl": "yes",
    "iconAsset": "Headache.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fheadache.webp?alt=media&token=70e4a67b-0370-4282-b16c-a21bea6043fd",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_headache.png?alt=media&token=4d0c43a9-d03b-4c8e-8ca2-2cf1530409ea"
  },
  
  "Stomach Pain": {
    "cm": {"hi": "पेट दर्द", "en": "Stomach Ache"},
    "caseCode": "Abdominal Pain",
    "aclist": ["Abdominal Pain"],
    "friendlyName": "pet dard, pet drd, stomack pain, stomach pen, pat main dard, pet mai sujan, stomuch ache, stomach ache, petdard, abdominal pain",
    "gm": {"hi": "पेट मुद्दे", "gid": "Stomach", "en": "Stomach Issues"},
    "impl": "yes",
    "iconAsset": "StomachPain.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2FStomach%20ache.webp?alt=media&token=25cf6236-b1c5-482b-8545-f4bc1ccd2779",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_abdomen_pain.png?alt=media&token=9e1e4fa0-224c-4156-aed4-890afa8bb002"
  },

  "Throat Discomfort": {
    "cm": {"hi": "गले में तकलीफ", "en": "Throat Discomfort"},
    "caseCode": "Throat Discomfort",
    "aclist": ["Throat Discomfort"],
    "friendlyName": "gale mai dard kharash throat pain chale jalan ulcer nigalne mai takleef throt kharkhari",
    "gm": {"hi": "गले में तकलीफ", "gid": "Throat Discomfort", "en": "Throat Discomfort"},
    "impl": "yes",
    "iconAsset": "ThroatDiscomfort.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fthroat_discomfort.webp?alt=media&token=b65003f7-b65f-42af-ae6e-5d30d21d0e24",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_throat_discomfort.png?alt=media&token=e1b77919-bc76-4196-8da3-820ab0484f0f"
  },

   "Gynaecology": {
     "friendlyName": "amenoriya amenorrhoea masik dharm menorahiya mainoriya menorrhagia aniyamit mahavari oligomenorrhea polymenorrhea menstrual pcod mahawari bachhedani pregnancy white discharge delivery pregnant garbvati garbhavati garbavyasa period",
     "aclist": ["Gynaecology"],
     "cm": {"hi": "महिला संबंधित रोग", "en": "Gynaec Related Issues", "smsen": "Gynaec issues"},
     "ageRange": [14, 150],
     "gender": "F",
     "gm": {"hi": "महिला संबंधित रोग", "gid": "Gynaecology", "en": "Gynaec Related Issues"},
     "caseCode": "Gynaecology",
     "impl": "yes",
     "iconAsset": "Gynaecology.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fgynaec%20issue.webp?alt=media&token=2286e942-e01a-4c2f-b9d2-6c32a5d24a6f",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_gynaecology.png?alt=media&token=cfb69ae7-89a6-4afe-b8ee-b6de1def1c88"
   },
   
    "Stool Related Issue": {
     "cm": {"hi": "मल संबंधित तकलीफ", "en": "Stool Related Issue"},
     "caseCode": "Stool Related Issue",
     "aclist": ["Stool Related Issue"],
     "friendlyName": "stool massa piles latrine letrein pet saaf",
     "gm": {"hi": "मल संबंधित तकलीफ", "gid": "Stool Related Issue", "en": "Stool Related Issue"},
     "impl": "yes",
     "iconAsset": "StoolRelatedIssue.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fstool.webp?alt=media&token=b0bb13a0-1ba1-4e19-9f51-72abdf4e3daf",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_stool_related_issue.png?alt=media&token=66f7ff6e-80e0-4fdf-9d40-6c0e71112948"
   },
 
   "Joint Pain": {
     "cm": {"hi": "जोड़ो में दर्द", "en": "Joint Pain"},
     "caseCode": "Joint Pain",
     "aclist": ["Joint Pain"],
     "friendlyName": "joddo me dard ghutne gathia rog gathiya gutna hat pav knee joint wrist finger pero paanvo leg hand ghutano jodo gardan shoulder kandha arthritis chalne chlne kohni gutne ghutnon solder sohouldr haadi haddi reed ",
     "gm": {"hi": "जोड़ो में दर्द", "gid": "Joints", "en": "Joint Pain"},
     "impl": "yes",
     "iconAsset": "JointPain.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fjoint_pain.webp?alt=media&token=598a4819-60c1-4ef6-910c-08d17316c24b",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_joint_pain.png?alt=media&token=bfe8493b-70e8-4522-99da-3d87f0f9859d"
   },
   
   "Ear Discomfort": {
     "cm": {"hi": "कान में तकलीफ", "en": "Ear Discomfort"},
     "caseCode": "Ear Discomfort",
     "aclist": ["Ear Discomfort"],
     "friendlyName": "ear pain pen puss kan bahana kandard sunne paani sunai kaan mawad kaano khujli pani hearing deaf ",
     "gm": {"hi": "कान में तकलीफ", "gid": "Ear Discomfort", "en": "Ear Discomfort"},
     "impl": "yes",
     "iconAsset": "EarDiscomfort.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fear%20discomfort.webp?alt=media&token=cb0a4698-0e22-4150-afc0-6efa04b5d620",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_ear_discomfort.png?alt=media&token=e1359cff-11cd-4bb8-947f-d8cce07705eb"
   },
   
   "Insect Bite": {
     "cm": {"hi": "कीड़े का काटना", "en": "Insect Bite"},
     "caseCode": "Insect Bite",
     "aclist": ["Insect Bite"],
     "friendlyName": "keeda kida katna katana makoda bhunga bite insect ",
     "gm": {"hi": "कीड़े का काटना", "gid": "Insect", "en": "Insect Bite"},
     "impl": "yes",
     "iconAsset": "InsectBite.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Finsect%20bite.webp?alt=media&token=4b9197d5-c700-47e4-be88-72f426a8d81b",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_insect_bite.png?alt=media&token=80ad2c06-c019-44e7-9f69-04c3b31cb334"
   },
   
   "Sleep Disturbance": {
     "cm": {"hi": "नींद में तकलीफ", "en": "Sleep Disturbance"},
     "caseCode": "Sleep Disturbance",
     "aclist": ["Sleep Disturbance"],
     "friendlyName": "neend nind sleep slip nend",
     "gm": {"hi": "नींद में तकलीफ", "gid": "Sleep Disturbance", "en": "Sleep Disturbance"},
     "impl": "yes",
     "iconAsset": "SleepDisturbance.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fsleep_disturbance.webp?alt=media&token=7a4ca197-9c49-4c63-a552-3d606373c9c5",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_sleep_disturbance.png?alt=media&token=dcf106be-b255-42e3-86e1-8e0242b142d9"
  },
 
   "Stress": {
     "cm": {"hi": "तनाव", "en": "Stress"},
     "caseCode": "Stress",
     "aclist": ["Stress"],
     "friendlyName": "tanav depression negative thoughts insomnia becheni pagalpan maansik mand khayal khyal",
     "gm": {"hi": "तनाव", "gid": "Stress", "en": "Stress"},
     "impl": "yes",
     "iconAsset": "Stress.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2FStress.webp?alt=media&token=598672ac-c999-4343-a42d-f15610641661",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_stool_related_issue.png?alt=media&token=66f7ff6e-80e0-4fdf-9d40-6c0e71112948"
  },

   "Hairfall": {
    'gm': {'gid': 'Skin', 'en': 'Skin & Hair', 'hi': 'त्वचा व बाल'},
    'cm': {'en': 'Hair fall', 'hi': 'बाल झड़ना'},
    'caseCode': "Hairfall", 'impl': 'yes', 'icon': 'v2_hairfall',
    'friendlyName': 'danddraf, fungal, ezima, hair, hairfall, baal, baal jhad, baal jhadna, dad, ganjapan, ganja',
    "iconAsset": "Skin.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fhairfall.webp?alt=media&token=92f8c7cf-cc75-4dd8-984b-1a939ebe2853",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_hairfall.png?alt=media&token=8229afda-959f-48da-b14e-02e0ca41e383"
 
  },

  "Skin": {
    'gm': {'gid': 'Skin', 'en': 'Skin & Hair', 'hi': 'त्वचा व बाल'},
    'cm': {'en': 'Skin Problems', 'hi': 'स्किन की समस्या'},
    'caseCode': "Skin", 'impl': 'yes', 'icon': 'v2_skin_issues',
    'friendlyName': 'skin, face, pimple, pimpal, acne, khujli, daad, ghamori, jalan, itch, massa, masse, crack, fatna, dry, rough, khujali, chot, rash, cut, ghaav, burn, daag, nishan, daane, dane, funsi, ring worm, charm chamdim, ghmoriya, alerji, allergy, pimpls, rashes, wrinkles, daag, fungal',
    "iconAsset": "Skin.webp",
    "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2FSkin-problem.webp?alt=media&token=11e84136-1788-4bdf-8252-df2b027fc8c3",
    "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv51_skin_issues.png?alt=media&token=8e27c031-8b88-413d-91a2-90a05ec5f977"
},
 
   "Vertigo in Young Female": {
    "friendlyName": "chakkar chakkar vartigo vertigo", 
    "aclist": [], 
    "cm": {"hi": "चक्कर", "en": "Vertigo"}, 
    "ageRange": [20, 49], 
    "gender": "F", 
    "gm": {"hi": "चक्कर", "gid": "Vertigo", "en": "Vertigo"}, 
    "caseCode": "Vertigo in Young Female", 
    "impl": "yes", 
   "iconAsset": "Vertigo.webp",
   "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fvertigo.webp?alt=media&token=74ceb226-c361-49e5-9a26-a50c8e325874",
   "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_vertigo.png?alt=media&token=8d2d0e90-0c95-4f7a-a0d4-c4a894723f2d"
   },
    
   "Vertigo in Old Age": {
      "friendlyName": "chakkar chakkar vartigo vertigo", 
      "aclist": [], 
      "cm": {"hi": "चक्कर", "en": "Vertigo"}, 
      "ageRange": [50, 150], 
      "gm": {"hi": "चक्कर", "gid": "Vertigo", "en": "Vertigo"}, 
      "caseCode": "Vertigo in Old Age", 
      "impl": "yes",
     "iconAsset": "Vertigo.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fvertigo.webp?alt=media&token=74ceb226-c361-49e5-9a26-a50c8e325874",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_vertigo.png?alt=media&token=8d2d0e90-0c95-4f7a-a0d4-c4a894723f2d"
   },
 
    "Vertigo in Young Male": {
       "friendlyName": "chakkar chakkar vartigo vertigo", 
       "aclist": ["Vertigo in Young Male", "Vertigo in Young Female", "Vertigo in Old Age"], 
       "cm": {"hi": "चक्कर", "en": "Vertigo"}, 
       "ageRange": [20, 49], 
       "gender": "M", 
       "gm": {"hi": "चक्कर", "gid": "Vertigo", "en": "Vertigo"}, 
       "caseCode": "Vertigo in Young Male", 
       "impl": "yes",
     "iconAsset": "Vertigo.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fvertigo.webp?alt=media&token=74ceb226-c361-49e5-9a26-a50c8e325874",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_vertigo.png?alt=media&token=8d2d0e90-0c95-4f7a-a0d4-c4a894723f2d"
    },
 
   "Dental or Oral Problems": {
      "cm": {"hi": "दांत या मुँह की समस्या", "en": "Dental or Oral Problems"}, 
      "caseCode": "Dental or Oral Problems", 
      "aclist": ["Dental or Oral Problems"],
      "friendlyName": "daant, tooth, teeth, bad smell, badbu, badboo, mouth, gums, daanto, masoodo, masoode, masuda, masude, masoore, masoora, dant, muh, mu, sadan, cavity, decay, sensitivity",
      "gm": {"hi": "दांत या मुँह की समस्या", "gid": "Dental or Oral Problems", "en": "Dental or Oral Problems"}, 
      "impl": "yes",
      "iconAsset": "Dental.webp",
       "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fdental.webp?alt=media&token=aab84e9c-c609-4c09-8487-131ffec1235b",
       "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_dental_and_oral_problems.png?alt=media&token=c37791d0-b9e8-48f4-a114-b18fee64d0a7"
    },
 
   "Nose Bleeding": {
     "cm": {"hi": "नाक से खून बहना", "en": "Nose Bleeding"},
     "caseCode": "Nose Bleeding",
     "aclist": ["Nose Bleeding"],
     "friendlyName": "nose bleeding naak nak khon khoon khun",
     "gm": {"hi": "नाक से खून बहना", "gid": "Nose Bleeding", "en": "Nose Bleeding"},
     "impl": "yes",
     "iconAsset": "NoseBleeding.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fnose%20bleeding.webp?alt=media&token=3bf2aa54-2af1-4977-8222-361fe2a72b47",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_nose_bleeding.png?alt=media&token=b072f450-eb6a-4928-b3ac-677602a82cee"
   },
 
   "Weakness Below 50 Yrs": {
       "friendlyName": "bhukh lagti chakkar weakness body ache bodyache kamjori paanv dukte pav jalan paw dhujte weekness sharir dard hath per sunn thakan drowsy kamjor sarir bhuk aalas thakaan wikness wajan  weekness thakavat", 
       "aclist": [], 
       "cm": {"ven": "Weakness", "hi": "कमजोरी", "en": "Weakness", "smsen": "Weakness"}, 
       "ageRange": [1, 49], 
       "gm": {"hi": "कमजोरी", "gid": "Weakness", "en": "Weakness"}, 
       "caseCode": "Weakness Below 50 Yrs",
       "impl": "yes", 
       "iconAsset": "Weakness.webp",
     	"icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fweakness.webp?alt=media&token=90100d93-5906-4b34-bf0e-0cb7510f4b5c",
       "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_weakness.png?alt=media&token=35f9eb89-0530-40bf-b116-ad625fb931e6"
    },
 
    "Weakness Above 50 Yrs": {
       "friendlyName": "weakness body ache bodyache kamjori jhanjhanahat chakkar paanv dukte pav mai jalan paw dhujte weekness sharir me dard hath per sunn thakan drowsy kamjor sarir bhukh bhuk aalas wajan  wikness weekness thakavat", 
       "aclist": ["Weakness Above 50 Yrs", "Weakness Below 50 Yrs"], 
       "cm": {"ven": "Weakness", "hi": "कमजोरी", "en": "Weakness", "smsen": "Weakness"},
       "ageRange": [50, 150], 
       "gm": {"hi": "कमजोरी", "gid": "Weakness", "en": "Weakness"},
       "caseCode": "Weakness Above 50 Yrs", 
       "impl": "yes", 
       "iconAsset": "Weakness.webp",
     	"icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fweakness-above-50.webp?alt=media&token=51cbc2e2-a271-4dfc-8a47-5fbd2cabbd9a",
       "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_weakness.png?alt=media&token=35f9eb89-0530-40bf-b116-ad625fb931e6"
    },
   
    "Eye Related Issues": {
       "cm": {"hi": "आँख संबंधी समस्या", "en": "Eye Related Issues"}, 
       "caseCode": "Eye Related Issues", 
       "aclist": ["Dental or Oral Problems"], 
       "friendlyName": "aankh, aankhein, aankho, netra, cornea, retina, conjunctivitis, redness in eye, itching in eye, vision, blindness, andhapa, cataract, motiya, motiyabind, glaucoma, glocoma, spectacles, chashma, lasik, lasic", 
       "gm": {"hi": "आँख संबंधी समस्या", "gid": "Eye Related Issues", "en": "Eye Related Issues"}, 
       "impl": "yes", 
       "iconAsset": "Eye.webp",
       "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Feye-related-issue.webp?alt=media&token=53f8c95e-3f0b-4050-88a2-b8ac3b430de6",
       "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_eye_related_issues.png?alt=media&token=c4ebdc04-9327-4428-acf5-3bfbb58b73d8"
     }, 
     
     "Diabetes": {
        "cm": {"hi": "डायबिटीज (शुगर)", "en": "Diabetes"}, 
        "caseCode": "Diabetes", 
        "aclist": ["Diabetes"], 
        "friendlyName": "diabetis, diabitis, sugar, shugar, suger, shuger, madhumeh, bahumutra, prameh, madhuprameh", 
        "gm": {"hi": "डायबिटीज (शुगर)", "gid": "Diabetes", "en": "Diabetes"}, 
        "impl": "yes", 
        "iconAsset": "Diabetes.webp",
       "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fdiabetes.webp?alt=media&token=2945f983-6a23-41ed-b368-20631ebfc14c",
       "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_diabetes.png?alt=media&token=8b4d23df-3388-4b70-9062-c4579ec8639b"
    },
        
    "Sexual Problems In Male": {
       "ageRange": [18, 100], 
       "aclist": ["Sexual Problems In Male", "Sexual Problems In Female"], 
       "cm": {"hi": "यौन समस्या", "en": "Sexual Problems"}, 
       "friendlyName": "yaun, yon, sex, sexual, gupt, guptrog, ling, penis, yoni, vagina, shighrapatan, sigrapatan, pme, premature, ejaculation, erection, erectile, ed, stambhandosh, impotence, napunsakta, skhalan, virya, viryaskhalan, nightfall, bedwetting, svapnadosh, swapnadosh, swapndosh, sperm, shukranu, orgasm, charamsukh, santushti, satisfaction, hastmaithun, masturbation, nirodh, condom, garbhnirodh, contraception", 
       "gender": "M", 
       "gm": {"hi": "यौन समस्या", "gid": "Sexual Problems", "en": "Sexual Problems"}, 
       "caseCode": "Sexual Problems In Male",
       "impl": "yes", 
      "iconAsset": "SexualMale.webp",
       "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fsexual-problem.webp?alt=media&token=0666da37-2266-4da3-91db-3d2e0dacc1a1",
       "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_sexual_problems_male.png?alt=media&token=207de710-e279-4551-b011-b120a4cd1347"
   },
    
    "Sexual Problems In Female": {
       "ageRange": [16, 100], 
       "aclist": [], 
       "cm": {"hi": "यौन समस्या", "en": "Sexual Problems"}, 
       "friendlyName": "yaun, yon, sex, sexual, gupt, guptrog, ling, penis, yoni, vagina, shighrapatan, sigrapatan, pme, premature, ejaculation, erection, erectile, ed, stambhandosh, impotence, napunsakta, skhalan, virya, viryaskhalan, nightfall, bedwetting, svapnadosh, swapnadosh, swapndosh, sperm, shukranu, orgasm, charamsukh, santushti, satisfaction, hastmaithun, masturbation, nirodh, condom, garbhnirodh, contraception", 
       "gender": "F", 
       "gm": {"hi": "यौन समस्या", 
       "gid": "Sexual Problems", 
       "en": "Sexual Problems"}, 
       "caseCode": "Sexual Problems In Female", 
       "impl": "yes",
     "iconAsset": "SexualFemale.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fsexual-problem.webp?alt=media&token=0666da37-2266-4da3-91db-3d2e0dacc1a1",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_sexual_problems_female.png?alt=media&token=55b9d121-8bd3-4d21-95d3-87ac6e346596"
    },
   
   "Hypertension": {
      "cm": {"hi": "हाइपरटेंशन (बीपी की बीमारी)", "en": "Hypertension"}, 
      "caseCode": "Hypertension", 
      "aclist": ["Hypertension"], 
      "friendlyName": "bp, blood, blood pressure, high bp, pressure, raktchaap, khoon ka dabaav, bipi", 
      "gm": {"hi": "हाइपरटेंशन (बीपी की बीमारी)", "gid": "Hypertension", "en": "Hypertension"}, 
      "impl": "yes",
      "iconAsset": "Hypertension.webp",
       "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fhypertension.webp?alt=media&token=09498491-903d-4c06-b0c0-5548e8fb12b3",
       "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_hypertension.png?alt=media&token=b24e06c8-eb90-4c79-85fe-e01790e845e6"
    }, 

    "Covid-19": {
      'gm': {'gid': 'COVID-19 Related', 'en': 'COVID-19 Related', 'hi': 'कोरोना संबंधी'},
      'cm': {'en': 'COVID-19 Related', 'hi': 'कोरोना संबंधी'},
      'impl': 'yes', 'caseCode': 'Covid-19', 'icon': 'v2_covid_advice', 'indev': false,
      'ageRange': [5, 150], 'friendlyName': 'jukam zukam sardi naak se pani cold cough khasi khansi khashi, kasi jukham zhukam common flu chik nose comman coman cuf kashi, comen commen behna covid cold',
      "iconAsset": "Miscellaneous.webp",
      "roundIconAsset": "RoundMiscellaneous.webp",
      "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2FCovid-19.webp?alt=media&token=5c910be6-86ad-4940-87cb-363ce763b6be",
      "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Fv5_covid_related.png?alt=media&token=e598f0f7-39e7-4c69-9eb5-e8906ff8a8cd"
    },
   
    "Other Problems": {
     "cm": {"hi": "अन्य तकलीफ़ें", "en": "Other Problems"},
     "caseCode": "Miscellaneous",
     "aclist": ["Miscellaneous"],
     "friendlyName": "",
     "gm": {"hi": "अन्य बीमारियाँ", "gid": "Miscellaneous", "en": "Miscellaneous"},
     "impl": "yes",
     "iconAsset": "Miscellaneous.webp",
     "roundIconAsset": "RoundMiscellaneous.webp",
     "icon_webp_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Frmc_miscellenous_case_icon.webp?alt=media&token=87737611-fce0-46bd-910f-eeb80e71b87c",
     "icon_png_url": "https://firebasestorage.googleapis.com/v0/b/medcords-lite.appspot.com/o/app_creatives%2Feconsult-cards-data-v2%2Fcase-listing-images%2Fpng-aayu-web%2Frmc_miscellenous_case_icon.png?alt=media&token=90879e10-4f71-45a7-ab23-59569d1b76d8"
   }   
}